import Api from '@/services/api'

export default {
  async fetchCargaLiquida (dados) {

    const response = await new Api()
      .post('Tributos/ObterCargaLiquida', dados)

    
    if (dados.base && response.dados.base) {
      return response.dados.base
    }

    return response.dados.dados
  }
}
